angular.module('swapick')
.controller('MessagesCtrl', MessagesCtrl);


function MessagesCtrl($scope, DataService, $ionicScrollDelegate, DataStrategies,
  initialLoaderManager, $q, $ionicHistory, $state, $stateParams, Entities) {

  DataStrategies.createPagerMethods(this, $scope,
    { method:DataService.messages, callMethodName : 'getList', pageSize:50 }
  );

  this.type = $stateParams.type || 'in';

  this.dropObject = (obj, idx) => {
    //#TODO: call remote API...
    this.objects.splice(idx, 1);
  }

  this.isMittente = (message) => {
    return message.mittente.id == this.user.id;
  }

  this.toType = (t) => {
    this.type = t;
    $ionicScrollDelegate.scrollTop();
  }

  this.loader = initialLoaderManager.makeLoader(()=>{
    return Entities.waitForUser()
    .then((u)=>{
        this.user = u;
        return this.loadPage()
    })
  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
    console.log(0, this);
    if(!this.objects.length){
      this.loader.load();
    }
  });

}



// WEBPACK FOOTER //
// ./src/controllers/messages-controller.js